import { Badge } from "./ui";
import { statusLabel, statusTone } from "../lib/format";
import type { CaseStatus } from "../lib/types";

export function StatusBadge({ status }: { status: CaseStatus }) {
  return <Badge tone={statusTone(status)}>{statusLabel(status)}</Badge>;
}
